export const features = [
  {
    key: "proximity-chat",
    title: "Proximity Chat",
    desc: "Voice rooms that light up when riders are near. Keep it raw, keep it real.",
    icon: "Radio",
  },
  {
    key: "marketplace",
    title: "Marketplace",
    desc: "Swap parts, rare drops, and gear — trusted by the pack.",
    icon: "ShoppingCart",
  },
  {
    key: "clans",
    title: "Clans",
    desc: "Form factions. Defend your tag. Earn respect.",
    icon: "Users",
  },
  {
    key: "track-days",
    title: "Track Days",
    desc: "Push redline. Organize private sessions. Log your best times.",
    icon: "Gauge",
  },
  {
    key: "group-rides",
    title: "Group Rides",
    desc: "Plan routes, share waypoints, roll as one.",
    icon: "Route",
  },
  {
    key: "ride-events",
    title: "Ride Events",
    desc: "From sunrise drifts to midnight runs — never miss a meet.",
    icon: "CalendarClock",
  },
];

export const faq = [
  {
    q: "Do I need to own a bike to join?",
    a: "No. If you love the culture, you\'re in. Riders, builders, dreamers — the network is yours.",
  },
  {
    q: "When is the app launching?",
    a: "Early access rolls out to the first Discord members. Get in now for updates — no hard timelines promised.",
  },
  {
    q: "Will my email be shared?",
    a: "No. Your email stays private. In this preview it\'s stored locally on your device only.",
  },
  // SEO-optimized FAQs
  {
    q: "What is RYDNET — a biker app or motorcycle social network?",
    a: "RYDNET is a cyberpunk-inspired motorcycle social app with proximity chat, group rides, clans, a marketplace, and ride events — built for riders and anyone who loves bike culture.",
  },
  {
    q: "How does proximity chat work for riders?",
    a: "Proximity chat opens low-latency voice rooms when riders are nearby. It\'s hands-off social — perfect for meetups, staging areas, and quick comms without public channels.",
  },
  {
    q: "Is this a good group ride app for motorcycles?",
    a: "Yes. Create routes, share waypoints, and coordinate departures. Riders can join or spectate, and get notified when crews roll out in their area.",
  },
  {
    q: "Does RYDNET include a motorcycle marketplace?",
    a: "The marketplace connects riders for parts, gear, and rare drops. List items, verify sellers, and trade with your local scene or trusted clans.",
  },
  {
    q: "What are clans and custom tags?",
    a: "Clans are digital crews with territory and identity. Earn your tag, reserve names, and rep your crew across rides, events, and the marketplace.",
  },
  {
    q: "Can non-riders use this motorcycle community app?",
    a: "Absolutely. Builders, photographers, and fans are welcome. Follow rides, join chats, and contribute without needing a bike.",
  },
  {
    q: "Is there a track day planner for motorcycles?",
    a: "Track Days lets you coordinate sessions with friends, log lap times, and share results — a clean hub for track-focused riders.",
  },
  {
    q: "How do I find motorcycle events near me?",
    a: "Use Ride Events to discover meets, charity runs, and track days in your area. Filter by distance, clan, and difficulty.",
  },
  {
    q: "Is RYDNET private?",
    a: "Privacy-first by design. You control your visibility, proximity, and what you share. No selling data — the grid respects the rider.",
  },
  {
    q: "Which platforms does this biker app support?",
    a: "Web is live as a preview; mobile access is planned next. Join the email list to be notified when iOS and Android roll out.",
  },
  {
    q: "How do I join early access?",
    a: "Enter your email on the landing page and tap Discord. Early access will prioritize the first members and active contributors.",
  },
];

export const seo = {
  title: "RYDNET — Cyberpunk Social for Bikers | Proximity Chat, Clans, Track Days",
  description:
    "RYDNET is a cyberpunk-inspired social grid for riders and bike lovers. Proximity chat, clans, marketplace, group rides and track days. Join the club.",
  ogImage: "/og-rydnet.png",
  url: "https://rydnet.app/",
};